export enum PdfColors {
    lines,
    propertyTableKeyBackground,
    propertyTableValueBackground,
}
